import i18n from '@/i18n';
import type { Country } from '@/types/country';
import type { Dish } from '@/types/dish';
import type { Composer } from 'vue-i18n';

// Initialisation i18n
export const t = (key: string, params: Record<string, unknown> = {}) => (i18n.global as unknown as Composer).t(key, params);

// DONNÉES COMMUNES
export const mockCountry: Country = {
  name: 'Switzerland',
  alpha2_code: 'CH',
  iso_code: '756',
  currency_symbol: 'CHF',
  flag_emoji: '🇨🇭',
};

export const baseDish: Omit<
  Dish,
  | 'id'
  | 'name'
  | 'ingredients'
  | 'prep_time_min'
  | 'cook_time_min'
  | 'allergens'
  | 'calories_kcal'
  | 'protein_g'
  | 'fat_g'
  | 'carbohydrates_g'
  | 'image_url_gastro'
  | 'image_url_bistro'
> = {
  author: 'mock-author',
  restaurant_id: 'mock-restaurant',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  difficulty: 2,
  ai_request_id: 0,
  servings: 4,
  created_using: 'ia',
  chill_time_min: 0,
  hasRecipe: true,
  isPlanned: null,
  image_url_user: undefined,
  loading: false,
  hasIngredientsInShoppingList: false,
  is_favorite: false,
  needs_recipe_update: false,
  selected_image: 'none',
  only_title: false,
  tags: [],
  saturated_fat_g: 10,
  sugars_g: 5,
  dietary_fiber_g: 5,
  salt_sodium_g: 1.1,
  is_template: false,
  country_alpha2_code: 'CH',
  country: mockCountry,
};
